"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var ReportRenderResource = /** @class */ (function (_super) {
    tslib_1.__extends(ReportRenderResource, _super);
    function ReportRenderResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportRenderResource.prototype.view = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrap('view').get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    /**
     * Returns a promise that resolves with `this` when status === DONE
     * @param timeoutSeconds Timeout in seconds (defaults to `ReportRenderResource.pollTimeout`)
     * @param iteration Start at iteration
     */
    ReportRenderResource.prototype.wait = function (options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var isDone, isError, intervalSeconds, interval_1, maxPolls, promise;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isDone = function () { return _this.attributes.status === 'DONE'; };
                        isError = function () { return _this.attributes.status === 'ERROR'; };
                        if (!isDone()) return [3 /*break*/, 1];
                        resolve(this);
                        return [3 /*break*/, 4];
                    case 1:
                        if (!isError()) return [3 /*break*/, 2];
                        reject(new Error("Attempting to render the report generated an error: " + JSON.stringify(this.attributes)));
                        return [3 /*break*/, 4];
                    case 2:
                        intervalSeconds = options.intervalSeconds || ReportRenderResource.pollInterval;
                        interval_1 = intervalSeconds * 1000;
                        maxPolls = options.pollTimeout || Math.ceil(ReportRenderResource.pollTimeout / intervalSeconds);
                        options._iter = options._iter || 1;
                        return [4 /*yield*/, this.update()];
                    case 3:
                        _a.sent();
                        if (isDone()) {
                            resolve(this);
                        }
                        else if (options._iter > maxPolls) {
                            reject(new Error('Reached timeout: report status never reached "DONE"'));
                        }
                        else {
                            promise = new Promise(function (otherResolve) {
                                options._iter++;
                                // Increment iteration -- Wait for n seconds then resolve recursively with this.wait()
                                setTimeout(function () { return otherResolve(_this.wait(options)); }, interval_1);
                            });
                            resolve(promise);
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    ReportRenderResource.endpoint = '/reports/renders';
    ReportRenderResource.MODEL_NAME = 'reportrender';
    ReportRenderResource.pollInterval = 3;
    ReportRenderResource.pollTimeout = 300;
    return ReportRenderResource;
}(base_1.default));
exports.default = ReportRenderResource;
//# sourceMappingURL=reportrender.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/reports/reportrender.js
// module id = v3yI
// module chunks = 0